import React from 'react';

import {
  ChangeLifestylesFiltersFunc,
  FetchLifestylesFilters
} from '../../../../../../lifestyles/lifestylesTypes';

import { useThreeDStockLifestylesSearch } from '../../../../../pages/ThreeDStockLifestyles/hooks/useThreeDStockLifestylesSearch';

import { ImageHelper } from '../../../../../../../helpers/ImageHelper';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { words } from '../../../../../../../locales/keys';

interface ThreeDStockLifestylesFiltersImageFilterBadgeProps {
  lifestylesFilters: FetchLifestylesFilters;
  changeLifestylesFilters: ChangeLifestylesFiltersFunc;
}

function ThreeDStockLifestylesFiltersImageFilterBadge({
  lifestylesFilters,
  changeLifestylesFilters
}: ThreeDStockLifestylesFiltersImageFilterBadgeProps) {
  const fileAttachmentFile =
    lifestylesFilters?.searchGlobalByLifestyle?.imageUrl || '';

  const { onClearSearchSimilarImage } = useThreeDStockLifestylesSearch({
    changeLifestylesFilters
  });

  if (!fileAttachmentFile) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="relative">
        <ImageHelper
          className="w-full h-auto rounded-lg shadow-sm"
          src={fileAttachmentFile}
          alt="imageSearch"
          version="original"
          tooltipAlt
          tooltipAltInteractive
          tooltipAltAppendToBody
        />

        <div className="absolute bottom-0 right-0 p-2">
          <PureButtonHelper
            dataGa="clear-search-similar-lifestyle-image-button"
            className="py-1 pl-2 pr-2 rounded-full inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base text-gray-900 bg-white hover:bg-gray-100 shadow-sm hover:shadow-md transition-colors duration-150 ease-out"
            onClick={onClearSearchSimilarImage}
            i18nText={words.clear}
          />
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockLifestylesFiltersImageFilterBadge;
